import { render, staticRenderFns } from "./ShouninComment.vue?vue&type=template&id=25a21214&scoped=true&"
import script from "./ShouninComment.vue?vue&type=script&lang=ts&"
export * from "./ShouninComment.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninComment.vue?vue&type=style&index=0&id=25a21214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a21214",
  null
  
)

export default component.exports